import{ useState } from 'react'
import { Modal, Typography, Select, Button, message } from 'antd'
import { useIntl } from 'react-intl'
import { GeneralDocumentsUploadType } from 'modules/entities/modules/documents'
import { useDocumentProcessing } from './DocumentProcessingContext'
import { useNotifications } from 'modules/ui';

const { Option } = Select
const { Title } = Typography


const DocumentTypeChange = ({ open, onClose }) => {
  const { changeDocumentType } = useDocumentProcessing()
    const notifications = useNotifications();
  const [documentType, setDocumentType] = useState('')
  const intl = useIntl();


 const options = Object.values(GeneralDocumentsUploadType).map(type => ({
        label: intl.formatMessage({
            id: `documents.generalUpload.type.${type}`,
        }),
        value: type,
    }));

  const handleSubmit = async () => {
    // Validate form
    try {
      if (!documentType) {
        return;
      }

      await changeDocumentType(documentType);

      notifications.success({
        message: intl.formatMessage({ id: 'file.type.submit.success' }),
      });
      onClose();
    } catch (error) {
      notifications.error({
        message: intl.formatMessage({ id: 'file.type.submit.success.failed' }),
        description: error.message,
      });
    }
  }

  return (
      <Modal 
          title={

            intl.formatMessage({ id: 'file.type.change' })
          }
          visible={open}
          footer={[
              <Button key="cancel" onClick={onClose}>
                  {intl.formatMessage({ id: 'cancel' })}
              </Button>,
              <Button key="submit" type="primary" onClick={handleSubmit}>
                  {intl.formatMessage({ id: 'file.type.change.submit' })}
              </Button>
      ]}
          onCancel={onClose}
    >
          <div style={{ marginBottom: 16 }}>
              <Title level={5}>
                  {intl.formatMessage({ id: 'document.type' })}
              </Title>
              <Select
                  placeholder={intl.formatMessage({
                            id: 'documents.generalUpload.type.placeholder',
                        })}
                  style={{ width: '100%' }}
                  value={documentType}
                  onChange={value => setDocumentType(value)}
        >
                  {options.map(type => (
                      <Option key={type.value} value={type.value}>
                          {type.label}
                      </Option>
          ))}
              </Select>
          </div>
      </Modal>
  )
}

export default DocumentTypeChange